var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canViewLoading)?_c('v-container',{attrs:{"id":"container"}},[_c('v-row',[_c('v-col',{staticClass:"vh-100 vw-100 d-flex ",attrs:{"cols":"12"}},[_c('main-loading')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }